import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { IProduct } from '../../../interfaces'
import {
  ISuggestedProductsState,
  SuggestedItemsStatus,
} from '../../../interfaces/suggestedItems'
import { markRowsSyncing, setSkuSyncing } from '../../skuSyncing'
import { ISuggestedProductsVariables } from '../../../graphQL/queries/suggestedItems/types'

export const initialState: ISuggestedProductsState = {
  suggestedProducts: [],
  numberOfItems: 0,
  status: 'OK',
  hideCarousel: true,
}

// Slice and reducers
export const suggestedProductsSlice = createSlice({
  name: 'suggestedProductsSlice',
  initialState,
  reducers: {
    setSuggestedProducts(state, { payload }: PayloadAction<IProduct[]>) {
      state.suggestedProducts = payload
      state.numberOfItems = payload.length
      state.hideCarousel = payload.length === 0
    },
    setStatus(state, { payload }: PayloadAction<SuggestedItemsStatus>) {
      state.status = payload
    },
    setRequest(state, { payload }: PayloadAction<ISuggestedProductsVariables>) {
      state.request = payload
    },
  },
  extraReducers: (builder) => {
    builder.addCase(setSkuSyncing, (state, { payload }) => {
      markRowsSyncing(state.suggestedProducts, payload)
    })
  },
})

export const { setSuggestedProducts, setStatus, setRequest } =
  suggestedProductsSlice.actions

export default suggestedProductsSlice.reducer
